"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepEqualMemo = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_fast_compare_1 = tslib_1.__importDefault(require("react-fast-compare"));
/**
 * This hook memoizes a value passed based on deep equality.
 * Note that it doesn't save you on calculation time like useMemo,
 * and it can get slow on huge objects. However it can help you avoid
 * re-renders by keeping the value reference identical.
 */
function useDeepEqualMemo(value) {
    var memoizedValue = (0, react_1.useRef)(value);
    // only update the value if it's not deep equal
    if (!(0, react_fast_compare_1.default)(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
exports.useDeepEqualMemo = useDeepEqualMemo;
//# sourceMappingURL=useDeepEqualMemo.js.map